import React from 'react';
import WaveField from './WaveField';

/**
 * Full-bleed backdrop for hero sections: a live canvas wave field plus the
 * veil that keeps headline text readable and melts the field into the page.
 */
export const HeroBackdrop = () => (
  <div className="hero-bg" aria-hidden="true">
    <WaveField />
    <div className="hero-bg-veil" />
  </div>
);

export default HeroBackdrop;
